import styled from "styled-components"
import { TextDiv, TextInput } from "../../common/Text"
import DropdownInput from "../DropdownInput"
import {
  Controller,
  FieldErrors,
  FieldValues,
  useFormContext,
} from "react-hook-form"

const SchoolInfoInput = () => {
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext()

  const error = errors.schoolInfo as FieldErrors<FieldValues>

  return (
    <RelativeDiv>
      <SchooInfoInputBox>
        <TextInput
          $isError={error?.school ? true : false}
          placeholder="소속 학교명"
          style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
          {...register("schoolInfo.school")}
        />
        <Controller
          control={control}
          name="schoolInfo.grade"
          render={({ field: { onChange } }) => (
            <DropdownInput
              handleName="학년"
              selectOptions={["1", "2", "3"]}
              onChange={onChange}
              mode="right"
              $isError={error?.grade ? true : false}
            />
          )}
        />
      </SchooInfoInputBox>
      {error?.school && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: 45,
          }}
        >
          * {error.school.message?.toString()}
        </TextDiv>
      )}
      {error?.grade && (
        <TextDiv
          fontSize={11}
          color="var(--custom-light-red)"
          $align="start"
          style={{
            marginTop: 10,
            paddingLeft: 25,
            position: "absolute",
            top: error?.school ? 65 : 45,
          }}
        >
          * {error.grade.message?.toString()}
        </TextDiv>
      )}
    </RelativeDiv>
  )
}

export default SchoolInfoInput

const RelativeDiv = styled.div`
  position: relative;
`

const SchooInfoInputBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  border-radius: 20px;

  > * {
    &:first-child {
      flex-grow: 1;
    }

    &:last-child {
      flex-basis: 150px;
      flex-shrink: 0;
    }
  }
`
